export default "__VITE_ASSET__BGsOkQJ2__"